<template>
  <!-- Se quito Notification Bell 17/05/2020 Por pedido de Oscar
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <i class="icon-bell"></i><b-badge pill variant="danger">{{puntos}}</b-badge>
    </template>

    <template slot="dropdown">
      <b-dropdown-header tag="div" class="dropdown-menu-lg text-center"><strong>Tiene {{puntos}} puntos para canjear</strong></b-dropdown-header>
    </template>
  </AppHeaderDropdown>-->
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownNotif',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { puntos: 0 }
  }
}
</script>
